
class TokenData {
  constructor(token) {
    this.appName = 'app';
    this.appId = null;
    this.clientId = null;
    this.userId = null;
    this.officeId = null;
    this.userGuid = null;
    this.officeGuid = null;

    if (token != null) {
      let jwt = require('jsonwebtoken');
      let decodedToken = jwt.decode(token);
      if (decodedToken != null) {
        let lwt = decodedToken['http://lwt'];
        if (lwt != null) {
          for (let globalId in lwt) {
            switch (globalId) {
              //Find Global Data
              case 'uid':
                this.userGuid = lwt[globalId];
                break;
              case 'cid':
                this.clientId = lwt[globalId];
                break;
              case 'oid':
                this.officeGuid = lwt[globalId];
                break;

              //Find AppId
              case 'bw':
                this.appId = globalId;
                this.appName = 'Back Office';
                break;
              case 'wc':
                this.appId = globalId;
                this.appName = 'WOLFconnect';
                break;
              case 'oo':
                this.appId = globalId;
                this.appName = 'Online Office';
                break;

              default:
                continue;
            }
          }

          //Find Legacy Data
          let legacyData = lwt[this.appId];
          if (legacyData != null) {
            for (let legacyId in legacyData) {
              switch (legacyId) {
                case 'uid':
                  this.userId = legacyData[legacyId];
                  break;
                case 'oid':
                  this.officeId = legacyData[legacyId];
                  break;
                default:
              }
            }
          }
        }
      }
    }
  }
  isValid = () => {
    return (
      this.appId &&
      this.clientId &&
      this.userId &&
      this.userGuid &&
      this.officeGuid
    );
  };
}

export default TokenData;
